import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export abstract class ArbetsorderKartutsnittBaseCommand extends BasicCommand<ArbetsorderKartutsnittBaseCommand> {
    arbetsorderId: number;
    kartutsnittId: string;

    get primaryKey(): IPrimaryKey<ArbetsorderKartutsnittBaseCommand> {
        return {
            arbetsorderId: this.arbetsorderId,
            kartutsnittId: this.kartutsnittId
        };
    }
    constructor($type, commandType) {
        super($type, "ArbetsorderKartutsnitt", commandType);
    }
}
